import {BillingAddressDto} from '../../../userway/sdk/UserWayApiClient';

export function billingAddressMap(billingAddress: BillingAddressDto) {
  return {
    line1: billingAddress.line1,
    state: billingAddress.state,
    city: billingAddress.city,
    country: billingAddress.country,
    postalCode: billingAddress.postalCode,
  };
}
